import React, { useEffect } from "react";
import "./CSS/Admin.css";
import Sidebar from "../Components/Sidebar/Sidebar";
import BoutiqueSidebar from "../Components/Sidebar/BoutiqueSidebar";
import { useAdminMode } from "../context/AdminModeContext";
import BoutiqueDashboard from "./BoutiqueDashboard";
import FabricDatabase from "./FabricDatabase";
import CustomPrinting from "./CustomPrinting";
import TailoringOrders from "./TailoringOrders";
import CRM from "./CRM";
import Analytics from "./Analytics";
import ComingSoon from "./ComingSoon";
import AddProduct from "../Components/AddProduct/AddProduct";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { canAccessPath, getHomePath, hasBoutiqueAccess, hasRetailAccess } from "../utils/menuAccess";
import ListProduct from "../Components/ListProduct/ListProduct";
import OrderDetails from "./Orders";
import VarietyAccessories from "./varietyAccessories";
import DesignPatterns from "./designPatterns";
import EditProduct from "../Components/EditProduct/editProduct";
import BrowseByVideos from "./browseByVideos";
import TopSellersRetro from "./topSellersRetro";
import LandingBanner from "./landingBanner";
import NewArrivals from "./newArrivals";
import BrowseCategory from "./browseCategory";
import FAQ from "./FAQ";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ExploreIdeas from "./exploreIdeas";
import FeaturedIn from "./featuredIn";
import PromoCodes from "./promoCodes";
import HomePageReviews from "./homeReviews";
import Customers from "./customers";
import Stock from "./Stock";
import SareeDetails from "./SareeDetails";
import SareeBarcodes from "./SareeBarcodes";
import UserManagement from "./UserManagement";
import ExcelUpload from "./ExcelUpload";
import GstReport from "./GstReport";
import Settings from "./Settings";
import AuditLog from "./AuditLog";
import Testimonials from "./Testimonials";
import ProductApprovals from "./ProductApprovals";

const Admin = () => {
  const { mode, setMode } = useAdminMode();
  const { pathname } = useLocation();

  // Keep the sidebar mode on a side the user actually has menus in
  useEffect(() => {
    if (mode === "boutique" && !hasBoutiqueAccess()) setMode("retail");
    else if (mode === "retail" && !hasRetailAccess()) setMode("boutique");
  }, [mode, setMode]);

  // Pages not ticked in the user's menu access redirect to their first allowed page
  if (!canAccessPath(pathname)) {
    return <Navigate to={getHomePath()} replace />;
  }

  return (
    <div className="admin">
      {mode === "boutique" ? <BoutiqueSidebar /> : <Sidebar />}
      <div className="admin-content">
      <Routes>

      <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/boutique/dashboard" element={<BoutiqueDashboard />} />
        <Route path="/boutique/fabric-database" element={<FabricDatabase />} />
        <Route path="/boutique/custom-printing" element={<CustomPrinting />} />
        <Route path="/boutique/order-management" element={<TailoringOrders />} />
        <Route path="/boutique/crm" element={<CRM />} />
        <Route path="/boutique/analytics" element={<Analytics />} />
        <Route path="/boutique/coming-soon" element={<ComingSoon />} />
        <Route path="/addproduct" element={<AddProduct />} />
        <Route path="/listproduct" element={<ListProduct />} />
        <Route path="/promo-codes" element={<PromoCodes />} />
        <Route path="/orders" element={<OrderDetails />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/saree-details" element={<SareeDetails />} />
        <Route path="/saree-barcodes" element={<SareeBarcodes />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/excel-upload" element={<ExcelUpload />} />
        <Route path="/gst-report" element={<GstReport />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="/product-approvals" element={<ProductApprovals />} />
        <Route path="/editproduct/:id" element={<EditProduct />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/explore-our-ideas" element={<ExploreIdeas />} />
        <Route path="/homepage/varietyofaccessories" element={<VarietyAccessories />} />
        <Route path="/homepage/shopbydesignpatterns" element={<DesignPatterns />} />
        <Route path="/homepage/browsebyvideos" element={<BrowseByVideos />} />
        <Route path="/homepage/topsellers-retrocollections" element={<TopSellersRetro />} />
        <Route path="/homepage/landingbanners" element={<LandingBanner />} />
        <Route path="/homepage/newarrivals" element={<NewArrivals />} />
        <Route path="/homepage/browsebycategory" element={<BrowseCategory />} />
        <Route path="/homepage/featured-in" element={<FeaturedIn />} />
        <Route path="/homepage/reviews" element={<HomePageReviews />} />
        <Route path="/homepage/testimonials" element={<Testimonials />} />
      </Routes>
      </div>
    </div>
  );
};

export default Admin;
